export default "__VITE_ASSET__DzG9C78m__"